import { observable } from "mobx";
import { urlApi } from "../../../../config/Constantes";


export class RelatorioAnaliticoStore {

    @observable loading;

    @observable bl;
    @observable da;
    @observable ce

    @observable mensagemErro;

    constructor() {
        this.loading = false;
    
        this.bl = "";
        this.ce = null;
        this.da = "";

        this.mensagemErro = "";
    
        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";

    }

    baixar = () => {
        this.loading = true;
        fetch(`${urlApi}/Entreposto/RelatorioRfb?blId=${this.bl}&ce=${this.ce}&da=${this.da}`).then(res => {
            if(res.status !== 200) {
                this.mensagemErro = "Não foi possível completar o download"; 
            } else {
                return res.blob();
            } 
        }).then(blob => {
            const url = window.URL.createObjectURL(blob)
            this.download.href = url
            this.download.download = `Relatório Analítico - Entreposto.pdf`
            this.download.click()
            window.URL.revokeObjectURL(url)
        }).catch(err => {
            console.error(err);
            this.mensagemErro = "Erro ao fazer o download"
        }).finally(() => {
            this.loading = false;
        });
    }

    setBl = (value) => {
        this.bl = value;
    }

    setCe = (value) => {
        if(value !== "" && value !== null ) {
            this.ce = value;
        } else {
            this.ce = null;
        }
    }

    setDa = (value) => {
        this.da = value;
    }

    fecharMensagemErro = () => {
        this.mensagemErro = "";
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatorioanalitico/stores/RelatorioAnaliticosStore.js